import { observer } from "mobx-react"
import { PSwitch, PSwitchProps } from "polaris-enhance"

import { Benifit } from "@/models/ICommon"

import useBenefit from "../BreathingLight/useBenefit"

function Switch(
  props: Omit<PSwitchProps, "value"> & { checked: boolean; benefits?: Benifit },
) {
  const { benefits } = props
  const { hasBenefits, handleClick } = useBenefit({ benefits })

  if (benefits && !hasBenefits) {
    return (
      <div className="inline-flex" onClick={handleClick}>
        <PSwitch value={props.checked} disabled onChange={() => {}} />
      </div>
    )
  }
  return <PSwitch {...props} value={props.checked} />
}

export default observer(Switch)
